import { onlineManager } from '@tanstack/react-query';
import storage from '../../../../../hooks/useStorage/useStorage';
import useOrderBookStore from '../../../../../stores/OrderBook/orderBook.store';
import { offlineUsersRepository } from '../../../repositories/offlineUsers.repository';

export const handleRemoveOfflineOrderFromOrderBook = (orderId: string) => {
  if (onlineManager.isOnline()) {
    const teamId = storage.getTeamId();

    storage.removeOrderBookStore(teamId, true);
  } else {
    const teamId = storage.getTeamId();
    const userTeam = offlineUsersRepository.getUserTeam(teamId);

    useOrderBookStore.getState().handleRemoveOrder(orderId, userTeam?.id);
  }
};
